import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';

import api from 'utils/axios';

export const GUEST_PORTAL_PUBLIC_QUERY_KEY = 'GUEST_PORTAL_PUBLIC_QUERY_KEY';

export const useAuthLoader = (tail?: string, tourRequest?: boolean) => {
  const { tourRequestId, guestPortalId } = useParams<{ tourRequestId?: string; guestPortalId?: string }>();
  const { data, error, isLoading } = useQuery([GUEST_PORTAL_PUBLIC_QUERY_KEY], ({ signal }) => {
    const url = tourRequest
      ? `tour_requests/${tourRequestId}${tail || ''}`
      : `guest_portals/${guestPortalId}${tail || ''}`;
    return api.get(url, { signal }).then(({ data }) => {
      if (!data) {
        throw new Error('Invalid data received');
      }

      return data;
    });
  });

  return {
    isLoading,
    error,
    data,
  };
};
